import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { BenefitsSection } from "@/components/home/BenefitsSection";
import { CollectionsSection } from "@/components/home/CollectionsSection";
import { HowItWorksSection } from "@/components/home/HowItWorksSection";
import { ReassuranceSection } from "@/components/home/ReassuranceSection";
import { CTASection } from "@/components/home/CTASection";
import { FAQSection } from "@/components/home/FAQSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { ProductGrid } from "@/components/shop/ProductGrid";
import { SocialProofBadge } from "@/components/social-proof/SocialProofBadge";
import { PressSection } from "@/components/home/PressSection";
import { BundleSection } from "@/components/home/BundleSection";
import { UGCSection } from "@/components/home/UGCSection";
import { UGCVideoSection } from "@/components/home/UGCVideoSection";
import { PaymentBadge } from "@/components/social-proof/PaymentBadge";
import { QuizSection } from "@/components/home/QuizSection";

const Index = () => {
  return (
    <Layout>
      {/* 1. HERO - First impression & value proposition */}
      <HeroSection />
      
      {/* 2. SOCIAL PROOF - Immediate credibility */}
      <section className="bg-secondary/30 border-y border-border/30">
        <div className="container-calim">
          <SocialProofBadge />
          <div className="flex justify-center pb-4">
            <PaymentBadge variant="compact" />
          </div>
        </div>
      </section>
      
      {/* 3. BENEFITS - Why choose us */}
      <BenefitsSection />
      
      {/* 4. UGC VIDEOS - Early social proof with real customers */}
      <UGCVideoSection />
      
      {/* 5. QUIZ - Engagement & personalization */}
      <QuizSection />
      
      {/* 6. PRESS - Authority & trust */}
      <PressSection />
      
      {/* 7. COLLECTIONS - Browse by category */}
      <CollectionsSection />
      
      {/* 8. BUNDLES - Upsell opportunity */}
      <BundleSection />
      
      {/* 9. ALL PRODUCTS - Complete catalog */}
      <section id="products" className="section-padding bg-secondary">
        <div className="container-calim">
          <div className="text-center mb-10 md:mb-12">
            <p className="text-subhead mb-3 md:mb-4">Shop</p>
            <h2 className="text-headline">All Products</h2>
          </div>
          <ProductGrid />
        </div>
      </section>
      
      {/* 10. HOW IT WORKS - Education after browsing */}
      <HowItWorksSection />
      
      {/* 11. TESTIMONIALS - Written reviews for depth */}
      <TestimonialsSection />
      
      {/* 12. UGC INSTAGRAM - Community & lifestyle */}
      <UGCSection />
      
      {/* 13. FAQ - Address objections */}
      <FAQSection />
      
      {/* 14. REASSURANCE - Final trust signals */}
      <ReassuranceSection />
      
      {/* 15. CTA - Final conversion push */}
      <CTASection />
    </Layout>
  );
};

export default Index;
